(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  function setupTemporaryVisualCopy(section) {
    if (document.body.classList.contains('wn-product--nami-focus')) return;
    const gallery = section.querySelector('[data-wn-gallery]');
    const copy = gallery?.querySelector('.wn-ux-gallery__copy');
    const slides = gallery ? [...gallery.querySelectorAll('[data-gallery-index]')] : [];
    if (!gallery || !copy || !slides.length || copy.dataset.wnTemporaryCopyReady === 'true') return;
    copy.dataset.wnTemporaryCopyReady = 'true';

    let hideTimer = 0;
    let lastIndex = -1;
    const clearTimer = () => { if (hideTimer) window.clearTimeout(hideTimer); hideTimer = 0; };
    const hide = () => { clearTimer(); copy.classList.add('is-hidden'); };
    const show = () => copy.classList.remove('is-hidden');
    const scheduleHide = () => {
      clearTimer();
      hideTimer = window.setTimeout(hide, mobileQuery.matches ? 3200 : 6000);
    };
    const activeIndex = () => {
      const active = slides.findIndex((slide) => slide.classList.contains('is-active'));
      return active >= 0 ? active : 0;
    };
    const sync = (force = false) => {
      const index = activeIndex();
      if (!force && index === lastIndex) return;
      lastIndex = index;
      if (index === 0) { show(); scheduleHide(); } else hide();
    };

    const observer = new MutationObserver(() => sync());
    slides.forEach((slide) => observer.observe(slide, { attributes: true, attributeFilter: ['class'] }));
    gallery.addEventListener('wn:product:media-change', () => window.requestAnimationFrame(() => sync(true)));
    mobileQuery.addEventListener?.('change', () => sync(true));
    sync(true);
  }

  function normalizeProductRouting(section) {
    if (document.body.classList.contains('wn-product--mika')) section.classList.add('wn-product-main--mika');
  }

  function boot(root = document) {
    root.querySelectorAll('.wn-product-main--universal').forEach((section) => {
      normalizeProductRouting(section);
      setupTemporaryVisualCopy(section);
    });
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
})();
